import { LOCALE_ID, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './public/login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ImprintComponent } from './public/imprint/imprint.component';
import { PrivacyComponent } from './public/privacy/privacy.component';
import { JwtModule } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment.development';
import { ForgotPasswordComponent } from './public/forgot-password/forgot-password.component';
import { MatIconModule } from '@angular/material/icon';
import { RegisterComponent } from './public/register/register.component';
import { PublicContainerComponent } from './components/public-container/public-container.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import localeDe from '@angular/common/locales/de';

registerLocaleData(localeDe);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ImprintComponent,
    PrivacyComponent,
    ForgotPasswordComponent,
    RegisterComponent,
    PublicContainerComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSnackBarModule,
    MatIconModule,
    MatTooltipModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem('access_token');
        },
        allowedDomains: [
          'localhost:8000',
          '192.168.2.205:8000',
          'api.azes.apps.hosting',
        ],
        disallowedRoutes: [`${environment.apiUrl}/auth/login`],
      },
    }),
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'de' }],
  bootstrap: [AppComponent],
})
export class AppModule {}
